<hr>

<div style="color: #878787; text-align: center;">
    <p style="font-size: 13px;">App Xofers - V{{Settings.version}}</p>
</div>
